export const QUERY_KEYS = {
  SEARCH_CONDITIONS: {
    AVAILABILITY_STATUS: "availabilityStatus",
    END_DATE: "endDate",
    EVENT_TYPE: "eventType",
    GENRE: "genre",
    KEYWORD: "keyword",
    PREFECTURES: "prefectures",
    START_DATE: "startDate",
  },
  TAB: "tab",
} as const;
